const initialState = {
  productItems: [],
  cartItems: [],
};
export default initialState;
